(function CalendarAddCategory($, Adzuki)
{
	"use strict";

	$(document).ready(function documentReady()
	{
		Adzuki.onload('CalendarSearchIndex/addCalendar', function onload() {
			$("#colorpicker").spectrum({
				color      : "#0080c5",
				showInitial: true,
				showInput  : true,
				change     : function changeColor(color) {
					var modifiedColor = color.toHexString().toUpperCase();

					$('#calendareventcategory-color').val(modifiedColor);
				}
			});
		});

		Adzuki.onload('CalendarSearchIndex/editCalendar', function onload() {
			$("#colorpicker").spectrum({
				color      : $('#calendareventcategory-existing_color').val(),
				showInitial: true,
				showInput  : true,
				change     : function changeColor(color) {
					var modifiedColor = color.toHexString().toUpperCase();

					$('#calendareventcategory-color').val(modifiedColor);
				}
			});
		});
	});

}(jQuery, window.Adzuki || {}));